// src/components/IdentityPage.jsx
import React, { useEffect, useState } from "react";
import MenuLayout from "./MenuLayout";
import "../styles/IdentityPage.css";
import { getVerification, submitVerification } from "../api/verification";
import { getProfile } from "../api/user";

const noteList = [
  "عکس باید واضح، بدون لرزش و با نور کافی باشد.",
  "عکس سلفی همراه کارت شناسایی باشد و تمام صورت و مدرک مشخص باشد.",
  "اطلاعات کارت باید خوانا و بدون بازتاب نور باشد.",
  "از عینک آفتابی و کلاه استفاده نکنید.",
  "فرمت های قابل قبول: JPG یا PNG.",
];

const IdentityPage = () => {
  const [fullName, setFullName] = useState("");
  const [nationalId, setNationalId] = useState("");
  const [email, setEmail] = useState("");
  const [birthday, setBirthday] = useState("");
  const [idCardFile, setIdCardFile] = useState(null);
  const [selfieFile, setSelfieFile] = useState(null);
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [statusMessage, setStatusMessage] = useState("");

  const resolveStatusMessage = (nextStatus, apiMessage) => {
    if (apiMessage) return apiMessage;
    const fallback = {
      pending: "در انتظار احراز هویت",
      approved: "احراز هویت تایید شد",
      rejected: "احراز هویت رد شده (مجددا انجام شود)",
      notsend: "درخواستی ثبت نشده است.",
    };
    return fallback[nextStatus] || "";
  };

  useEffect(() => {
    const fetchVerification = async () => {
      try {
        const [verData, profileData] = await Promise.allSettled([getVerification(), getProfile()]);

        if (profileData.status === "fulfilled") {
          const p = profileData.value || {};
          setFullName(p.full_name || p.user?.full_name || "");
          setEmail(p.email || p.user?.email || "");
          setBirthday(p.birth_date || "");
        }

        if (verData.status === "fulfilled") {
          const data = verData.value || {};
          setNationalId(data?.national_id || "");
          const nextStatus = data?.status || "";
          setStatus(nextStatus);
          setStatusMessage(resolveStatusMessage(nextStatus, data?.status_message || data?.message));
        } else if (verData.status === "rejected") {
          // Ignore missing verification (404) and only surface other errors.
          if (verData.reason?.status && verData.reason.status !== 404) {
            setError(verData.reason.message || "خطا در دریافت وضعیت احراز هویت");
          }
        }
      } catch (err) {
        setError(err.message || "خطا در دریافت وضعیت احراز هویت");
      }
    };
    fetchVerification();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!fullName || !nationalId || !email || !birthday || !idCardFile || !selfieFile) {
      setError("لطفا همه فیلدها را کامل کنید.");
      return;
    }
    setError("");
    setStatusMessage("");
    setLoading(true);
    const formData = new FormData();
    formData.append("full_name", fullName);
    formData.append("email", email);
    formData.append("birthday", birthday);
    formData.append("national_id", nationalId);
    formData.append("id_card_image", idCardFile);
    formData.append("selfie_with_id", selfieFile);
    try {
      const res = await submitVerification(formData);
      const nextStatus = res?.status || "pending";
      setStatus(nextStatus);
      setStatusMessage(resolveStatusMessage(nextStatus, res?.status_message || res?.message));
    } catch (err) {
      setError(err.message || "خطا در ثبت احراز هویت");
    } finally {
      setLoading(false);
    }
  };

  const isPending = status === "pending";
  const isLocked = status === "pending" || status === "approved";
  const canSubmit = !status || status === "notsend" || status === "rejected";
  const approvalLabel = statusMessage || "احراز هویت تایید شد";

  return (
    <MenuLayout>
      <div className="identity-page">
        <header className="identity-header">
          <h1 className="identity-title">احراز هویت</h1>
          <p className="identity-subtitle">
            برای امنیت حساب، احراز هویت ضروری است. لطفا اطلاعات خود را با دقت وارد کنید.
          </p>
        </header>

        <form className="identity-form" onSubmit={handleSubmit}>
          <div className="identity-info-grid">
            <div className="identity-info-card">
              <span className="identity-label">نام و نام خانوادگی:</span>
              <input
                className="identity-input"
                type="text"
                value={fullName}
                onChange={(e) => setFullName(e.target.value)}
                disabled={isPending}
              />
            </div>
            <div className="identity-info-card">
              <span className="identity-label">کد ملی:</span>
              <input
                className="identity-input"
                type="text"
                value={nationalId}
                onChange={(e) => setNationalId(e.target.value)}
                disabled={isPending}
              />
            </div>
            <div className="identity-info-card">
              <span className="identity-label">ایمیل:</span>
              <input
                className="identity-input"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={isPending}
              />
            </div>
            <div className="identity-info-card">
              <span className="identity-label">تاریخ تولد:</span>
              <input
                className="identity-input"
                type="text"
                placeholder="مثال: 1400/01/01"
                value={birthday}
                onChange={(e) => setBirthday(e.target.value)}
                disabled={isPending}
              />
            </div>
          </div>

          <div className="identity-guide-row">
            <div className="identity-notes identity-notes-wide">
              <div className="identity-notes-title">راهنمای عکس</div>
              <div className="identity-guide-content">
                <ul className="identity-notes-list">
                  {noteList.map((n, idx) => (
                    <li key={idx}>
                      <span className="identity-check">✓</span>
                      <span>{n}</span>
                    </li>
                  ))}
                </ul>
                <div className="identity-guide-media">
                  <img className="identity-guide-image" src="/images/identity.png" alt="نمونه عکس احراز هویت" />
                  {status === "approved" && <div className="identity-approval-badge">{approvalLabel}</div>}
                </div>
              </div>
            </div>
          </div>

          <div className="identity-upload-grid">
            <div className="identity-upload-card">
              <div className="identity-upload-icon">📄</div>
              <h3 className="identity-upload-title">بارگذاری کارت شناسایی</h3>
              <p className="identity-upload-desc">کارت ملی، شناسنامه یا پاسپورت با کیفیت خوانا</p>
              <input
                id="upload-idcard"
                type="file"
                className="identity-upload-input"
                accept="image/*"
                onChange={(e) => setIdCardFile(e.target.files?.[0] || null)}
                disabled={isLocked}
              />
              <label className="identity-upload-btn" htmlFor="upload-idcard">
                انتخاب فایل
              </label>
              {idCardFile && <div className="identity-file-name">{idCardFile.name}</div>}
            </div>

            <div className="identity-upload-card">
              <div className="identity-upload-icon">🤳</div>
              <h3 className="identity-upload-title">سلفی همراه کارت</h3>
              <p className="identity-upload-desc">تمام صورت و تمام مدرک در تصویر باشد</p>
              <input
                id="upload-selfie"
                type="file"
                className="identity-upload-input"
                accept="image/*"
                onChange={(e) => setSelfieFile(e.target.files?.[0] || null)}
                disabled={isLocked}
              />
              <label className="identity-upload-btn" htmlFor="upload-selfie">
                انتخاب فایل
              </label>
              {selfieFile && <div className="identity-file-name">{selfieFile.name}</div>}
            </div>
          </div>

          {isPending && <div className="identity-pending">درخواست شما در حال بررسی است.</div>}
          {error && <div className="identity-error">{error}</div>}
          {statusMessage && status !== "approved" && <div className="identity-success">{statusMessage}</div>}

          {canSubmit && (
            <button type="submit" className="identity-submit-btn" disabled={loading || isPending}>
              {loading ? "در حال ارسال..." : "ارسال درخواست احراز هویت"}
            </button>
          )}
        </form>
      </div>
    </MenuLayout>
  );
};

export default IdentityPage;
